import { useState } from 'react';
import Link from 'next/link';
import { DateTime } from 'luxon';

import CloudinaryImage from '../common/CloudinaryImage';

const style = {
  episodesLists: {},
  li: {
    borderRadius: '6px',
  },
  figure: {
    backgroundRepeat: 'no-repeat',
    width: '213px',
    backgroundSize: 'cover',
    height: '207px',
    borderRadius: '6px',
  },
};

export default function PodcastEpisode({
  podcastDetail,
  isPodCast,
  podcastSeasons,
}) {
  const [activeTab, setActiveTab] = useState(isPodCast);
  const handleTab = item => {
    setActiveTab(item.season);
  };

  return (
    <div>
      <ul className="flex border-b border-[#7F7D7DA8] mb-5 gap-10 text-[32px] text-[#161616] font-[700]">
        {podcastSeasons?.map(item => (
          <li
            key={item?.id}
            onClick={() => handleTab(item)}
            className={`cursor-pointer ${activeTab === item?.season ? 'border-b-[3px] border-[#0050D5]' : ''}`}
          >
            {item?.season}
          </li>
        ))}
      </ul>

      <ul style={style.episodesLists}>
        {podcastDetail?.map(
          (data, index) =>
            activeTab === data?.attributes?.Season && (
              <li
                className={`${index === 0 ? '' : 'mt-5'} p-4 bg-[#F1F6FF] flex md:flex-nowrap flex-wrap hover:shadow-[0px_0px_0px_2px_#4152ee] transation-custom hover:scale-[1.03]  
                    rounded-[8px] overflow-hidden gap-6 group`}
                style={style.li}
                key={data?.id}
              >
                <div className="lg:basis-3/12 md:basis-4/12 md:mb-0 mb-3 episodes-content-img flex items-start">
                  <Link href={`/podcast/${data?.attributes?.slug}`}>
                    <CloudinaryImage
                      backendImgUrl={
                        data?.attributes?.playlist_data?.playlist_img?.data
                          ?.attributes?.url
                      }
                      alt={
                        data?.attributes?.playlist_data?.playlist_img?.data
                          ?.attributes?.alternativeText
                      }
                      className="w-[100%] md:max-h-[250px] w-full"
                      type={'smallimg'}
                    />
                  </Link>
                </div>
                <div className="lg:basis-6/6 md:basis-5/6 episodes-content-block">
                  <h5 className="mb-2 lg:text-[24px] md:text-[19px] text-[16px] font-[700] line-clamp-2 leading-tight">
                    <Link
                      href={`/podcast/${data?.attributes?.slug}`}
                      className="text-[#0E0E0E] group-hover:text-[#4152ee]"
                    >
                      {data?.attributes?.playlist_data?.h1_purple}
                    </Link>
                  </h5>
                  <div className="flex flex-wrap text-[15px] text-[#000] font-[600] gap-x-7 gap-b-3 mb-3">
                    <label>
                      {DateTime.fromJSDate(
                        data?.attributes?.playlist_data?.playlist_date &&
                          new Date(
                            data?.attributes?.playlist_data?.playlist_date
                          )
                      ).toFormat('MMM dd yyyy')}
                    </label>

                    <label className="">
                      <span className="font-[700]">Duration:</span>{' '}
                      {data?.attributes?.duration}
                    </label>
                    <label>
                      <span className="font-[700]">
                        {data?.attributes?.playlist_data?.host_purple} :
                      </span>
                      {data?.attributes?.playlist_data?.host_name_black}
                    </label>
                    <label>
                      <span className="font-[700]">
                        {data?.attributes?.playlist_data?.guest_purple} :
                      </span>
                      {data?.attributes?.playlist_data?.guest_name_black}
                    </label>
                  </div>
                  <p>
                    {data?.attributes?.playlist_data?.playlist_body?.length >
                    150
                      ? `${
                          data?.attributes?.playlist_data?.playlist_body.slice(
                            0,
                            150
                          ) + '....'
                        }`
                      : data?.attributes?.playlist_data?.playlist_body}
                  </p>

                  <Link
                    href={`/podcast/${data?.attributes?.slug}`}
                    className="border border-[#062454] bg-[#F1F6FF] text-[16px] font-[600] text-[#062454] inline-flex items-center justify-center rounded-[100px_!important] py-1 pl-4 pr-2 mt-4"
                  >
                    Listen Now
                    <span className="ml-4 bg-[#062454] w-[35px] h-[35px] flex items-center justify-center rounded-[100%]">
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 8L0.5 15.7942L0.5 0.205771L14 8Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </Link>
                </div>
              </li>
            )
        )}
      </ul>
    </div>
  );
}
